import(/* webpackMode: "eager" */ "/home/interim/frontend/app/cookies/page.tsx");
